import styled from "styled-components";

export const StyledHero = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 150px 20px 50px;
  ${({ backgroundImage }) =>
    backgroundImage &&
    `
    padding: 150px 20px 200px;
    `} width: 100%;
  ${(props) =>
    props.secondary &&
    `background-color: ${props.theme.colors.primary.lighter};`} ${(props) =>
    props.screenHeight && "height: 90vh;"};
`;

StyledHero.displayName = "StyledHero";
